import React, { useState } from "react";
import { Link } from "react-router-dom";

const BlogsPage = () => {
  // NOTE: This is a placeholder blog system. Replace with actual content and images when ready.
  const [blogs] = useState([
    {
      id: 1,
      title: "The Importance of Professional Facility Maintenance",
      excerpt: "Discover how regular facility maintenance can extend the lifespan of your equipment and reduce operational costs.",
      content:
        "Proper facility maintenance is crucial for ensuring a safe, efficient, and productive work environment. Regular maintenance prevents equipment failures, extends asset lifespan, and reduces emergency repair costs. At Aerolines Engineering & Construction, we provide comprehensive maintenance solutions tailored to your facility's specific needs.",
      author: "Aerolines Team",
      date: "February 10, 2026",
      category: "Facility Maintenance",
      //image: "https://via.placeholder.com/400x300?text=Facility+Maintenance",
    },
    {
      id: 2,
      title: "Automated Testing Equipment: Enhancing Quality Control",
      excerpt: "Learn how automated testing equipment improves product quality and increases production efficiency.",
      content:
        "Automated testing equipment plays a vital role in modern manufacturing and quality assurance. It ensures consistency, reduces human error, and accelerates the testing process. Our automated testing solutions are designed to meet industry standards and improve your overall product quality.",
      author: "Aerolines Team",
      date: "February 5, 2026",
      category: "Automation",
      //image: "https://via.placeholder.com/400x300?text=Automated+Testing",
    },
    {
      id: 3,
      title: "Electrical Works: Safety Standards and Best Practices",
      excerpt: "Explore the best practices in electrical engineering to ensure safety and compliance with regulatory standards.",
      content:
        "Electrical safety is paramount in any industrial or commercial setting. Our team of certified electrical engineers ensures that all installations meet local and international safety standards. We provide comprehensive electrical solutions including installation, maintenance, and upgrades.",
      author: "Aerolines Team",
      date: "January 28, 2026",
      category: "Electrical Engineering",
      //image: "https://via.placeholder.com/400x300?text=Electrical+Works",
    },
    {
      id: 4,
      title: "PLC Control Systems: Modernizing Industrial Operations",
      excerpt: "Understand how PLC systems can streamline your industrial processes and improve operational efficiency.",
      content:
        "Programmable Logic Controllers (PLCs) are essential for automating industrial processes. They provide real-time monitoring, precise control, and high reliability. Our PLC solutions are customized to optimize your production workflow and reduce downtime.",
      author: "Aerolines Team",
      date: "January 20, 2026",
      category: "Control Systems",
      //image: "https://via.placeholder.com/400x300?text=PLC+Systems",
    },
    {
      id: 5,
      title: "Civil Engineering Projects: Case Studies and Success Stories",
      excerpt: "Review our successful civil engineering projects and learn about our expertise in construction and infrastructure.",
      content:
        "From renovation projects to large-scale construction, Aerolines Engineering & Construction has successfully completed numerous civil engineering projects. Our expertise spans commercial, industrial, and residential sectors, with a strong commitment to quality and safety.",
      author: "Aerolines Team",
      date: "January 15, 2026",
      category: "Civil Engineering",
      //image: "https://via.placeholder.com/400x300?text=Civil+Engineering",
    },
    {
      id: 6,
      title: "Industrial Automation: Reducing Costs and Improving Output",
      excerpt: "Discover how industrial automation can boost your production capacity while reducing operational expenses.",
      content:
        "Industrial automation integrates various technologies to streamline manufacturing processes. By implementing automated systems, companies experience increased productivity, reduced labor costs, and improved product consistency. Our automation solutions are scalable and adaptable to your business needs.",
      author: "Aerolines Team",
      date: "January 10, 2026",
      category: "Automation",
      //image: "https://via.placeholder.com/400x300?text=Industrial+Automation",
    },
  ]);

  const [selectedCategory, setSelectedCategory] = useState("All");

  const categories = [
    "All",
    "Facility Maintenance",
    "Automation",
    "Electrical Engineering",
    "Control Systems",
    "Civil Engineering",
  ];

  const filteredBlogs =
    selectedCategory === "All"
      ? blogs
      : blogs.filter((blog) => blog.category === selectedCategory);

  return (
    <div id="blogs-page">
      {/* Header */}
      <header
        id="blog-header"
        style={{
          backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(img/banners/banner1.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "400px",
          display: "flex",
          alignItems: "center",
          color: "white",
          textAlign: "center",
        }}
      >
        <div className="container" style={{ width: "100%" }}>
          <h1 style={{ fontSize: "48px", fontWeight: "bold", marginBottom: "20px" }}>
            Our Blog
          </h1>
          <p style={{ fontSize: "20px", margin: "0" }}>
            Industry insights, tips, and best practices
          </p>
        </div>
      </header>

      {/* Navigation and Filter */}
      <div className="container" style={{ marginTop: "40px", marginBottom: "40px" }}>
        <div className="row">
          <div className="col-md-12">
            <nav className="blog-category-filter" style={{ textAlign: "center", marginBottom: "30px" }}>
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  style={{
                    padding: "10px 20px",
                    margin: "5px",
                    border: selectedCategory === category ? "2px solid #ffcc00" : "2px solid #ddd",
                    backgroundColor: selectedCategory === category ? "#ffcc00" : "transparent",
                    color: selectedCategory === category ? "#333" : "#666",
                    cursor: "pointer",
                    borderRadius: "5px",
                    fontWeight: selectedCategory === category ? "600" : "400",
                    transition: "all 0.3s ease",
                  }}
                >
                  {category}
                </button>
              ))}
            </nav>
          </div>
        </div>

        {/* Blog Posts Grid */}
        <div className="row">
          {filteredBlogs.map((blog) => (
            <div key={blog.id} className="col-md-4 col-sm-6 col-xs-12" style={{ marginBottom: "30px" }}>
              <article
                className="blog-card"
                style={{
                  border: "1px solid #eee",
                  borderRadius: "8px",
                  overflow: "hidden",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow = "0 5px 15px rgba(0, 0, 0, 0.2)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.1)";
                }}
              >
                {/* Blog Image */}
                {/* <img
                  src={blog.image}
                  alt={blog.title}
                  style={{
                    width: "100%",
                    height: "200px",
                    objectFit: "cover",
                  }}
                /> */}

                {/* Blog Content */}
                <div style={{ padding: "20px", flex: 1, display: "flex", flexDirection: "column" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "10px",
                      justifyContent: "space-between",
                    }}
                  >
                    <span
                      className="blog-category"
                      style={{
                        backgroundColor: "#ffcc00",
                        color: "#333",
                        padding: "5px 10px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                      }}
                    >
                      {blog.category}
                    </span>
                    <span
                      className="blog-date"
                      style={{
                        fontSize: "12px",
                        color: "#999",
                      }}
                    >
                      {blog.date}
                    </span>
                  </div>

                  <h2
                    className="blog-title"
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      color: "#333",
                      marginBottom: "10px",
                      flex: 1,
                    }}
                  >
                    {blog.title}
                  </h2>

                  <p
                    className="blog-excerpt"
                    style={{
                      fontSize: "14px",
                      color: "#666",
                      marginBottom: "15px",
                      lineHeight: "1.6",
                    }}
                  >
                    {blog.excerpt}
                  </p>

                  <Link
                    to={`/blog/${blog.id}`}
                    className="blog-read-more"
                    style={{
                      color: "#2196F3",
                      textDecoration: "none",
                      fontWeight: "600",
                      marginTop: "auto",
                    }}
                  >
                    Read More →
                  </Link>
                </div>
              </article>
            </div>
          ))}
        </div>

        {/* No Results Message */}
        {filteredBlogs.length === 0 && (
          <div className="row">
            <div className="col-md-12 text-center">
              <p style={{ fontSize: "18px", color: "#999", margin: "40px 0" }}>
                No blog posts found in this category.
              </p>
            </div>
          </div>
        )}
      </div>

      {/* Call to Action */}
      <section
        style={{
          backgroundColor: "#f5f5f5",
          padding: "60px 20px",
          marginTop: "40px",
          textAlign: "center",
        }}
      >
        <div className="container">
          <h2 style={{ marginBottom: "20px" }}>Stay Updated with Our Latest Articles</h2>
          <p style={{ fontSize: "16px", color: "#666", marginBottom: "30px" }}>
            Subscribe to our newsletter for industry insights and best practices.
          </p>
          <Link to="/" className="btn btn-custom btn-lg">
            Back to Home
          </Link>
        </div>
      </section>
    </div>
  );
};

export default BlogsPage;
